export const ROOT_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8000'
  : window.location.origin;

export const BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8000/api/v1'
  : `${window.location.origin}/api/v1`;

export const FILE_UPLOAD_MAX_SIZE = 100 * 1024 * 1024;

export const ALLOWED_IMG_FORMATS = ['image/png', 'image/jpeg', 'application/pdf'];

export const DRAWER_BREAK_POINT = 700;

export const DEBOUNCE_TIME = 400; // in milliseconds

export const FLAG_VALUE = {
  critical: 'CRITICAL',
  warning: 'WARNING',
  success: 'SUCCESS',
  none: 'NONE'
};

export const USA_STATES = [
  { code: 'ALL', name: 'All' },
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
];

export const CASE_SCHEDULE_OP_MODE = {
  noOp: 'NO_OP',
  newSchedule: 'NEW_SCHEDULE',
  caseBlockNewCase: 'CASE_BLOCK_NEW_CASE',
  updatedSchedule: 'UPDATE_SCHEDULE',
  markedForCreation: 'MARKED_FOR_CREATION',
  markedForDeletion: 'MARKED_FOR_DELETION'
};

export const PATIENT_TYPE = {
  IN: 'InPt',
  OUT: 'OutPt'
};

export const ORIGIN = {
  scheduleGrid: 'SCHEDULE-GRID',
  ganttGrid: 'GANTT-GRID'
};

export const FORM_TYPE = {
  faceSheet: 'faceSheet',
  recordsLabs: 'recordsLabs',
  recordsEkg: 'recordsEkg',
  recordsImaging: 'recordsImaging',
  recordsConsults: 'recordsConsults',
  consentsSurgery: 'consentsSurgery',
  consentsAnesthesia: 'consentsAnesthesia',
  nursing: 'nursing',
  nursingPreOp: 'nursingPreOp',
  nursingIntraOp: 'nursingIntraOp',
  nursingPostOp: 'nursingPostOp',
  surgeon: 'surgeon',
  surgeonPreOp: 'surgeonPreOp',
  surgeonIntraOp: 'surgeonIntraOp',
  surgeonPostOp: 'surgeonPostOp',
  anesthesiaPreOp: 'anesthesiaPreOp',
  anesthesiaIntraOp: 'anesthesiaIntraOp',
  anesthesiaPostOp: 'anesthesiaPostOp',
  ordersPreOp: 'ordersPreOp',
  ordersIntraOp: 'ordersIntraOp',
  ordersPostOp: 'ordersPostOp',
  discharge: 'discharge'
};
